import React from 'react';
import PropTypes from 'prop-types';
import { Chip } from '@mui/material';
import appColors from '../common/app_colors';

const INDICATOR_COLORS = appColors.pills;
const TEXT_COLORS = appColors.text;

const PostIndicator = ({
  type = '', text = '', sx = {}, onClick = undefined,
}) => {
  const styles = {
    recommendation: {
      backgroundColor: INDICATOR_COLORS.darkBlue,
    },
    connection: {
      backgroundColor: INDICATOR_COLORS.lightBlue,
    },
    resources: {
      backgroundColor: INDICATOR_COLORS.darkBlue,
    },
    affirmation: {
      backgroundColor: INDICATOR_COLORS.green,
    },
    celebration: {
      backgroundColor: INDICATOR_COLORS.gold,
    },
    meet: {
      backgroundColor: INDICATOR_COLORS.lightBlack,
    },
    share: {
      backgroundColor: INDICATOR_COLORS.gold,
    },
    // TODO: Remove these 4 once i update api
    health: {
      backgroundColor: INDICATOR_COLORS.lightBlue,
    },
    passion: {
      backgroundColor: INDICATOR_COLORS.orange,
    },
    academic: {
      backgroundColor: INDICATOR_COLORS.green,
    },
    career: {
      backgroundColor: INDICATOR_COLORS.lightBlack,
    },
    panel: {
      backgroundColor: INDICATOR_COLORS.skyBlue,
    },
    group: {
      backgroundColor: INDICATOR_COLORS.orange2,
    },
    mindsets: {
      backgroundColor: INDICATOR_COLORS.skyBlue,
    },
    fundamentals: {
      backgroundColor: INDICATOR_COLORS.skyBlue,
    },
    wellness: {
      backgroundColor: INDICATOR_COLORS.lightBlue,
    },
    finances: {
      backgroundColor: INDICATOR_COLORS.lightBlue,
    },
    academics: {
      backgroundColor: INDICATOR_COLORS.darkBlue,
    },
    careers: {
      backgroundColor: INDICATOR_COLORS.darkBlue,
    },
    catchup_network: {
      backgroundColor: INDICATOR_COLORS.skyBlue,
    },
  };

  const typographyStyles = {
    color: TEXT_COLORS.whiteText,
    fontSize: '0.625rem',
    fontWeight: 700,
    textTransform: 'capitalize',
    fontFamily: '"Sarabun", arial, sans-serif',
    height: '24px',
    '& .MuiChip-label': {
      px: 1.25,
    },
    maxWidth: '175px',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
  };

  return <Chip label={text || type} onClick={onClick} sx={{ ...styles[type], ...typographyStyles, ...sx }} />;
};

PostIndicator.propTypes = {
  type: PropTypes.string,
  text: PropTypes.string,
  sx: PropTypes.oneOfType([PropTypes.object]),
  onClick: PropTypes.func,
};


export default PostIndicator;
